export default {
  首页: "Főoldal",
  资产: "Eszközök",
  币币: "Spot",
  快捷买币: "Gyors kriptóvásárlás",
  "支持多种方式购买，购买更简单": "Egyszerű vásárlás több fizetési móddal",
  语言设置: "Nyelv beállítása",
  确认恢复: "Visszaállítás megerősítése",
  "输入邮箱，方便我们联系您":
    "Adja meg e-mail címét, hogy felvehessük Önnel a kapcsolatot",
  划转: "Átvezetés",
  行情: "Piac",
  "24H成交": "24 órás forgalom",
  累计收益: "Teljes hozam",
  充值时间: "Befizetés dátuma",
  到期时间: "Lejárat dátuma",
  数量: "Mennyiség",
  操作: "Művelet",
  资产信息: "Eszköz információk",
  复制地址: "Cím másolása",
  链名称: "Lánc neve",
  充值地址: "Befizetési cím",
  收款地址: "Fogadási cím",
  账单: "Számla",
  提现金额: "Kivonási összeg",
  接收地址: "Fogadási cím",
  交易密码: "Kereskedési jelszó",
  提现全部: "Összes kivétele",
  保存图片: "Kép mentése",
  输入您的交易密码: "Adja meg kereskedési jelszavát",
  确定: "Megerősítés",
  地址: "Cím",
  注册时间: "Regisztráció dátuma",
  取消: "Mégse",
  是否划转: "Átvezetés?",
  登录: "Bejelentkezés",
  我的地址: "Címeim",
  登录密码和交易密码: "Bejelentkezési jelszó és kereskedési jelszó",
  注册: "Regisztráció",
  密码: "Jelszó",
  设置密码: "Jelszó beállítása",
  重复密码: "Jelszó megerősítése",
  新密码: "Új jelszó",
  确认新密码: "Új jelszó megerősítése",
  充值: "Befizetés",
  充值货币: "Pénznem befizetése",
  合约账户充值: "Befizetés határidős számlára",
  账户充值: "Befizetés számlára",
  其他: "Egyéb",
  我的邀请码: "Meghívókód",
  提现: "Kivétel",
  客服: "Ügyfélszolgálat",
  持有详情: "Tartás részletei",
  请输入内容: "Adja meg a tartalmat",
  邀请好友来领取奖励: "Hívjon meg barátokat, és kapjon jutalmakat",
  复制链接: "Link másolása",
  重复设置新的密码: "Új jelszó megerősítése",
  保存: "Mentés",
  我的: "Számlám",
  "邮箱/手机号": "E-mail/Telefonszám",
  备注: "Megjegyzés",
  地址管理: "Címkezelés",
  我的团队: "Csapatom",
  联系我们: "Kapcsolat",
  竭诚为您服务: "Rendelkezésére állunk",
  提取收益: "Hozam kivétele",
  带给我的收益: "Generált hozam",
  添加: "Hozzáadás",
  名称: "Név",
  添加地址: "Cím hozzáadása",
  修改地址: "Cím módosítása",
  可提现: "Kivehető",
  安全中心: "Biztonsági központ",
  收益划转: "Hozam átvezetése",
  通知中心: "Értesítések",
  "累计收益:": "Teljes hozam:",
  注册用户: "Regisztrált felhasználók",
  奖励规则: "Jutalmazási szabályok",
  帮助反馈: "Segítség és visszajelzés",
  邀请好友: "Barátok meghívása",
  恢复身份: "Személyazonosság helyreállítása",
  选择语言: "Nyelvválasztás",
  设置新的密码: "Új jelszó beállítása",
  暂无活动: "Nincs aktív esemény",
  "月增长量(+)": "Havi növekedés (+)",
  可提取: "Kivehető",
  反馈类型: "Visszajelzés típusa",
  赠送: "Ajándék",
  已经复制: "Másolva",
  保存成功: "Sikeresen mentve",
  划转成功: "Sikeres átvezetés",
  过期: "Lejárt",
  提交成功: "Sikeresen elküldve",
  "服务器繁忙，稍后在试": "A szerver foglalt, próbálja újra később",
  全部: "Mind",
  一级: "1. szint",
  二级: "2. szint",
  三级: "3. szint",
  级: "szint",
  删除成功: "Sikeresen törölve",
  选择地址: "Cím kiválasztása",
  不再提醒: "Ne jelenjen meg újra",
  "最小充值金额：": "Minimális befizetési összeg:",
  选择币种: "Kriptovaluta kiválasztása",
  输入投资金额: "Adja meg a befektetési összeget",
  输入账户密码: "Adja meg a számla jelszavát",
  投资: "Befektetés",
  订单编号: "Rendelésszám",
  投资周期: "Befektetési időszak",
  投资资金: "Befektetett összeg",
  投资时间: "Befektetés ideje",
  状态: "Állapot",
  投资中: "Aktív",
  已到期: "Lejárt",
  暂无数据: "Nincs adat",
  转入: "Átvezetés ide:",
  邮箱: "E-mail",
  请输入邮箱: "Adja meg e-mail címét",
  请输入格式正确的邮箱: "Adjon meg egy érvényes e-mail címet",
  请输入验证码: "Adja meg az ellenőrző kódot",
  获取验证码: "Ellenőrző kód kérése",
  请输入邀请码: "Adja meg a meghívókódot",
  今天: "Ma",
  昨天: "Tegnap",
  最近七天: "Utolsó 7 nap",
  邀请: "Meghívás",
  购买数量: "Vásárlás mennyisége",
  产品详情: "Termék részletei",
  币种: "Kriptovaluta",
  利息币种: "Hozam pénzneme",
  理财类型: "Pénzügyi termék típusa",
  产品费率: "Termékdíjak",
  进行中: "Aktív",
  每天: "Naponta",
  请输入搜索关键词: "Adja meg a keresőkifejezést",
  通知: "Értesítések",
  查看更多: "Továbbiak",
  理财宝: "Pénzügyi termékek",
  周期: "Futamidő",
  年利率: "Éves kamatláb (APY)",
  更多产品: "További termékek",
  灵活存取: "Rugalmas megtakarítás",
  稳定收益: "Stabil hozam",
  合约指南: "Határidős útmutató",
  资金划转出: "Kimenő átvezetés",
  矿池收益: "Bányászati jutalom",
  提现手续费: "Kivételi díj",
  冻结资金: "Zárolt pénzeszközök",
  解冻资金: "Zárolt pénzeszközök feloldása",
  闪兑支出: "Gyorsváltás kiadás",
  闪兑收入: "Gyorsváltás bevétel",
  闪兑手续费: "Gyorsváltási díj",
  合约支出: "Határidős kiadás",
  合约收入: "Határidős bevétel",
  输入的金额不可大于可用金额:
    "Az összeg nem haladhatja meg a rendelkezésre álló összeget",
  全部兑换成功: "Teljes váltás sikeres",
  返回: "Vissza",
  查看历史: "Előzmények megtekintése",
  闪兑历史: "Gyorsváltás előzményei",
  支付: "Fizetés",
  获取: "Megszerzés",
  时间: "Idő",
  手续费: "Tranzakciós díj",
  折扣: "Kedvezmény",
  价格: "Ár",
  逐仓: "Izolált fedezet",
  全仓: "Keresztfedezet",
  市价委托: "Piaci megbízás",
  限价委托: "Limit megbízás",
  请输入本金: "Adja meg a tőkét",
  请输入价格: "Adja meg az árat",
  "可做空/做多": "Lehetőség short/long pozícióra",
  设置止盈止损: "Take-profit/Stop-loss beállítása",
  止盈价: "Take-profit ár",
  止损价: "Stop-loss ár",
  成本: "Költségár",
  做多: "Long",
  做空: "Short",
  仓位信息: "Pozíció információk",
  一键平仓: "Pozíció zárása (egy kattintás)",
  永续: "Perpetual",
  浮动盈亏: "Nem realizált nyereség/veszteség",
  平仓: "Pozíció zárása",
  反向开仓: "Fordított pozíció nyitása",
  一键撤销: "Összes visszavonása (egy kattintás)",
  倍杠杆: "szeres tőkeáttétel",
  执行价格: "Végrehajtási ár",
  委托数量: "Megbízás mennyisége",
  保证金: "Fedezet",
  成交价: "Végrehajtási ár",
  创建时间: "Létrehozás ideje",
  撤销: "Visszavonás",
  合约市场: "Határidős piac",
  交易方向: "Kereskedési irány",
  委托价格: "Megbízás ára",
  委托金额: "Megbízás összege",
  资金费率: "Finanszírozási ráta",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Időszakos díj, amelyet a hosszú és rövid pozíciók fizetnek, 8 óránként elszámolva.",
  "资金费率为正，多方向空方支付资金费用。":
    "Pozitív finanszírozási ráta esetén a hosszú pozíciók fizetnek a rövid pozícióknak.",
  "资金费率为负，空方向多方支付资金费用。":
    "Negatív finanszírozási ráta esetén a rövid pozíciók fizetnek a hosszú pozícióknak.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Biztosan fordított pozíciót kíván nyitni? Ez megvásárolja az aktuális pozíciójával ellentétes irányt.",
  "仓位止盈/止损": "Pozíció take-profit/stop-loss",
  合约名称: "Határidős szerződés",
  开仓价格: "Nyitóár",
  指数价格: "Indexár",
  止盈设置: "Take-profit beállítások",
  请输入止盈价: "Adja meg a take-profit árat",
  "当指数价格触达*时，将会触发委托平仓":
    "Amikor az indexár eléri a * értéket, egy zárási megbízás aktiválódik.",
  预计盈亏: "Várható nyereség/veszteség",
  当前仓位: "Aktuális pozíció",
  平仓金额: "Zárási összeg",
  仓位模式: "Pozíció mód",
  全仓模式: "Keresztfedezeti mód",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Keresztfedezeti módban a határidős számláján lévő összes rendelkezésre álló pénzeszköz fedezetként kerül felhasználásra. Likvidáció akkor következik be, ha a veszteség meghaladja a teljes egyenlegét, ami a teljes fedezet és pozíció elvesztését eredményezi.",
  逐仓模式: "Izolált fedezeti mód",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Meghatározott összegű fedezet kerül egy pozícióhoz. Ha a fedezeti veszteség a fenntartási fedezeti szint alá csökken, a pozíció likvidálásra kerül. Izolált fedezeti módban növelheti vagy csökkentheti a fedezetet ehhez a pozícióhoz.",
  "是否撤销？": "Visszavonja a megbízást?",
  "是否一键撤销？": "Visszavonja az összes megbízást?",
  "是否一键平仓？": "Bezárja az összes pozíciót?",
  持仓保证金: "Aktuális pozíció fedezete",
  风险率: "Kockázati ráta",
  未实现盈亏: "Nem realizált nyereség/veszteség",
  可用保证金: "Rendelkezésre álló fedezet",
  净值: "Nettó érték",
  账户余额: "Számlaegyenleg",
  合约计算器: "Határidős kalkulátor",
  交易记录: "Tranzakció előzmények",
  "*倍杠杆": "*szeres tőkeáttétel",
  "平仓盈亏：": "Zárt nyereség/veszteség:",
  时间筛选: "Idő szűrő",
  仓位类型: "Pozíció típusa",
  订单状态: "Rendelés állapota",
  订单类型: "Megbízás típusa",
  平仓价格: "Zárási ár",
  持仓数量: "Pozíció mennyisége",
  "手续费(%)": "Tranzakciós díj (%)",
  平仓时间: "Zárás ideje",
  平仓类型: "Zárás típusa",
  手动平仓: "Kézi zárás",
  强制平仓: "Kényszerlikvidáció",
  近1天: "Utolsó nap",
  近7天: "Utolsó 7 nap",
  近30天: "Utolsó 30 nap",
  近180天: "Utolsó 180 nap",
  持仓: "Nyitott pozíció",
  已取消: "Visszavonva",
  分时: "Napközbeni",
  "24H额(USDT)": "24 órás forgalom (USDT)",
  "24H低": "24 órás mélypont",
  "24H量(BTC)": "24 órás forgalom (BTC)",
  "24H高": "24 órás csúcs",
  "10秒": "10 másodperc",
  "30秒": "30 másodperc",
  "1分": "1 perc",
  "3分": "3 perc",
  "5分": "5 perc",
  "30分": "30 perc",
  "1小时": "1 óra",
  "4小时": "4 óra",
  "8小时": "8 óra",
  "1天": "1 nap",
  "1周": "1 hét",
  "1月": "1 hónap",
  单向持仓: "Egyirányú pozíció",
  杠杆: "Tőkeáttétel",
  仓位: "Pozíció",
  计算结果: "Eredmény",
  盈亏: "Nyereség/Veszteség",
  收益率: "Hozam",
  计算结果仅供参考: "Az eredmény tájékoztató jellegű",
  成交后仓位大小: "Pozíció mérete végrehajtás után",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Az eredmény tájékoztató jellegű, a tényleges eredmények a díjak miatt eltérhetnek.",
  目标价格: "Célár",
  开始计算: "Számítás",
  强平价格: "Likvidációs ár",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Befizetés előtt alaposan ellenőrizze a lánc nevét. A hibás befizetéseket nem lehet visszavonni. A minimális befizetési összeg *. Az ennél kisebb összegeket nem dolgozzuk fel. Ne küldjön más eszközöket erre a címre. Ne használjon ICO vagy közösségi finanszírozási címeket kivételekhez.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "A minimális kivonási mennyiség *. A kivételi díjakat levonjuk a kivonási összegből. Ellenőrizze alaposan a fogadó címét. Ne küldjön *-t a *-n kívüli címekre. Ne használjon ICO vagy közösségi finanszírozási címeket.",
  退出登录: "Kijelentkezés",
  加仓: "Pozíció növelése",
  新增仓位: "Új pozíció",
  输入加仓金额: "Adja meg a pozíciónövelés összegét",
  "当前可用:": "Jelenleg rendelkezésre áll:",
  资产账单: "Eszközszámla",
  保存二维码: "QR kód mentése",
  温馨提示: "Megjegyzés",
  "请注意：您当前使用的网络":
    "Megjegyzés: Jelenleg a következő hálózatot használja",
  输入提现地址: "Adja meg a kivonási címet",
  "可用金额：": "Rendelkezésre álló összeg:",
  输入资产密码: "Adja meg az eszközjelszót",
  可用手续费: "Rendelkezésre álló díj",
  "折扣%": "Kedvezmény %",
  实扣手续费: "Ténylegesen felszámított díj",
  实际到账: "Ténylegesen kapott összeg",
  未设置资产密码: "Az eszközjelszó nincs beállítva",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Biztonsága érdekében állítson be eszközjelszót a kivétel előtt.",
  热榜: "Népszerű",
  涨幅榜: "Legnagyobb emelkedők",
  跌幅榜: "Legnagyobb esők",
  成交额榜: "Forgalmi rangsor",
  关于我们: "Rólunk",
  登录密码: "Bejelentkezési jelszó",
  设置: "Beállítások",
  资产密码: "Eszközjelszó",
  修改登录密码: "Bejelentkezési jelszó módosítása",
  原密码: "Régi jelszó",
  请输入新密码: "Adja meg az új jelszót",
  请输入原密码: "Adja meg a régi jelszót",
  确认密码: "Jelszó megerősítése",
  确定修改: "Módosítás megerősítése",
  修改资产密码: "Eszközjelszó módosítása",
  验证码: "Ellenőrző kód",
  资产密码使用提示: "Eszközjelszó tippek",
  "资产密码用于转移、提取资产和交易。":
    "Az eszközjelszót az eszközök átvezetéséhez, kivételéhez és kereskedéséhez használjuk.",
  "创建与登录密码不同的资产密码。":
    "Hozzon létre egy, a bejelentkezési jelszótól eltérő eszközjelszót.",
  "定期更改您的资产密码。": "Rendszeresen változtassa meg eszközjelszavát.",
  提币历史: "Kivételi előzmények",
  "金额/余额": "Összeg/Egyenleg",
  "手续费/折扣": "Díj/Kedvezmény",
  自选: "Kedvencek",
  现货: "Spot",
  市价: "Piaci ár",
  止损设置: "Stop-loss beállítások",
  合约K线图: "Határidős grafikon",
  "24H量": "24 órás forgalom",
  "24H额": "24 órás forgalom (USDT)",
  合作指南: "Partner útmutató",
  盈亏计算: "Nyereség/veszteség számítás",
  当前可用: "Jelenleg rendelkezésre áll",
  请输入加仓金额: "Adja meg a pozíciónövelés összegét",
  请重新输入加仓金额: "Adja meg újra a pozíciónövelés összegét",
  平仓数量: "Zárandó mennyiség",
  欢迎登录: "Üdvözöljük újra",
  "忘记密码?": "Elfelejtette jelszavát?",
  "还没有账号？": "Még nincs fiókja?",
  立即注册: "Regisztráció most",
  繁體中文: "Hagyományos kínai",
  找回密码: "Jelszó visszaállítása",
  下一步: "Tovább",
  注册账户: "Fiók regisztrálása",
  "请输入邀请码(选填)": "Adja meg a meghívókódot (opcionális)",
  谢邀豪礼: "Meghívási bónusz",
  "24小时邀请好友排名": "24 órás meghívási ranglista",
  "*人": "* fő",
  "差*人": "Még * fő hiányzik",
  "已超过10万人，每月轻松赚钱":
    "Több mint 100 000 felhasználó, könnyedén kereshet minden hónapban",
  最高: "Maximum",
  邀请链接: "Meghívási link",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Osztozzon a barátai által generált tranzakciós díjakban (spot, határidős, tőkeáttétel, gyorsváltás).",
  平台和您一起分享手续费: "Osztozzon a tranzakciós díjakban a platformmal",
  "*级": "* szint",
  规则: "Szabályok",
  我的好友: "Barátaim",
  好友详情: "Barát részletei",
  获得好友佣金方案: "Baráti jutalékterv",
  我的等级: "Szintem",
  我的邀请数据: "Meghívási statisztikáim",
  当前等级: "Jelenlegi szint",
  平台奖励您: "Platform jutalma Önnek",
  最高可获取平台奖励: "Maximális platformjutalom",
  邀请规则: "Meghívási szabályok",
  "邀请*级有效好友": "Hívjon meg aktív barátokat * szinten",
  好友等级: "Barát szintje",
  人: "fő",
  奖金派送: "Bónusz kifizetése",
  平台奖励: "Platform jutalom",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "A platform fenntartja a végső értelmezés jogát. Csalárd tevékenység esetén a jutalmakat visszavonjuk, és fiókját zároljuk. Az elvesztett eszközök nem állíthatók vissza.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Fiókjának aktívnak kell lennie, amelyet legalább * USDT értékű befizetésként határozunk meg bármely kriptovalutában.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "A meghívott barátjának aktív alsóbb szintűnek kell lennie, amelyet legalább * USDT értékű befizetésként határozunk meg.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "A meghívó és a meghívott nem oszthatja meg ugyanazt az IP-címet.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "A VIP szintet a meghívott * szintű barátok száma határozza meg.",
  佣金成分: "Jutalék összetevők",
  收益统计: "Hozam statisztika",
  昨日收益: "Tegnapi hozam",
  月收益: "Havi hozam",
  获取收益: "Hozam megszerzése",
  "总收益：": "Teljes hozam:",
  "*级好友": "* szintű barátok",
  理财购买: "Pénzügyi termék vásárlása",
  期限: "Futamidő",
  可用金额: "Rendelkezésre álló összeg",
  预估收益: "Becsült hozam",
  申购上限: "Maximális vásárlás",
  项目剩余: "Fennmaradó projekt",
  "买入后预计*(SGT)开始计算收益。":
    "A hozam várhatóan *(SGT) körül kezdődik a vásárlás után.",
  计息日: "Kamat számításának kezdete",
  申购日: "Vásárlás dátuma",
  到账日: "Jóváírás dátuma",
  到期自动续投: "Automatikus újrabefektetés lejáratkor",
  申购: "Vásárlás",
  搜索理财项目: "Pénzügyi termék keresése",
  超高年化随心选: "Válasszon a magas hozamú termékek közül",
  "自由选择理财币种，稳定超额收益":
    "Szabadon válassza ki kriptovalutáját a stabil, átlag feletti hozam érdekében",
  理财总资产: "Teljes befektetett eszköz",
  申购数量: "Vásárolandó mennyiség",
  立即购买: "Azonnali vásárlás",
  年化收益率: "Éves százalékos hozam (APY)",
  理财订单: "Pénzügyi termék rendelések",
  持有: "Tartásban",
  申购份额: "Vásárolt részesedés",
  到账日期: "Jóváírás dátuma",
  申购成功: "Sikeres vásárlás",
  到期: "Lejárt",
  是否选择做多: "Long pozíció nyitása?",
  "可用余额为0 不能操作": "Az egyenleg 0, a művelet nem lehetséges",
  福利中心: "Bónuszközpont",
  奖励记录: "Jutalmazási előzmények",
  我获取到的奖励: "Megszerzett jutalmaim",
  总价值: "Teljes érték",
  新手任务: "Új felhasználói feladatok",
  身份认证: "Személyazonosság igazolás (KYC)",
  身份验证: "Személyazonosság igazolás",
  去验证: "Igazolás most",
  审核中: "Folyamatban",
  已验证: "Igazolva",
  认证失败: "Igazolás sikertelen",
  基础认证: "Alap igazolás",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Megjegyzés: Az igazolt információkat nem lehet módosítani. Pontos adatokat adjon meg.",
  "国家/地区": "Ország/Régió",
  请选择: "Válasszon",
  证件类型: "Dokumentum típusa",
  证件编码: "Dokumentum száma",
  身份证: "Személyi igazolvány",
  护照: "Útlevél",
  驾驶证: "Vezetői engedély",
  请输入编码: "Adja meg a számot",
  名字: "Keresztnév",
  请输入: "Adja meg",
  中间名: "Középső név",
  选填: "Opcionális",
  姓氏: "Vezetéknév",
  中国: "Kína",
  身份上传: "Személyazonosság igazolás feltöltése",
  上传身份证: "Személyi igazolvány feltöltése",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Töltsön fel JPG/JPEG/PNG formátumban. Győződjön meg róla, hogy a képek tiszták, teljesek és egyenletesen megvilágítottak. Maximum *MB.",
  确定提交: "Beküldés",
  去认证: "Igazolás",
  挑战任务: "Kihívás feladatok",
  注册认证任务: "Regisztrációs és igazolási feladat",
  完成注册认证即可领取:
    "Végezze el a regisztrációt és az igazolást a következő megszerzéséhez",
  领取奖励: "Jutalom átvétele",
  新人豪礼: "Üdvözlő bónusz",
  "参与人数：": "Résztvevők száma:",
  条件: "Feltétel",
  入金量: "Befizetési összeg",
  完成: "Kész",
  任务奖励: "Feladat jutalom",
  距任务更新: "Feladat frissítéséig",
  "条件：": "Feltétel:",
  活动规则: "Esemény szabályai",
  奖励明细: "Jutalom részletei",
  已获得: "Megszerzett",
  交易奖励: "Kereskedési jutalom",
  Win奖励: "WIN jutalom",
  已领取: "Átvett",
  亏损金额超过: "Veszteség összege meghaladja",
  单笔开仓金额超过: "Egyszeri megbízás összege meghaladja",
  交易量: "Kereskedési volumen",
  待完成: "Függőben",
  入金: "Befizetés",
  盈利金额超过: "Nyereség összege meghaladja",
  开仓金额: "Megbízás összege",
  开仓金: "Megbízás összege",
  盈利: "Nyereség",
  亏损: "Veszteség",
  领取: "Átvétel",
  未领取: "Nem vették át",
  待领取: "Átvételre vár",
  再交易: "Kereskedjen tovább",
  即可获得: "a megszerzéshez",
  领取成功: "Sikeres átvétel",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Minden esemény a záró időpontban kerül elszámolásra. A jutalmak ezt követően lejárnak.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. A megszerzett hozam a jutalomszámlájára kerül jóváírásra, amelyet bármikor átválthat vagy kivehet.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. A jutalom kriptovalutája a feladattól függ.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. A platform fenntartja a végső értelmezés jogát. A feladatokkal való visszaélés esetén a jutalmakat visszatartjuk, és fiókját zárolhatjuk.",
  成长学院: "Akadémia",
  "区块链 & 加密货币": "Blockchain és kriptovaluta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Teljes körű útmutatója a kriptovalutákhoz. Végigkísérjük Önt a kriptó útján.",
  "全仓合约定单的全部保证金。":
    "Teljes fedezet a keresztfedezeti határidős megbízásokhoz.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Számlaegyenleg + (nem realizált nyereség/veszteség - díjak - finanszírozási kamatok) = Nettó érték / Felhasznált fedezet * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "A nem realizált nyereség/veszteség közvetlenül befolyásolja a 'rendelkezésre álló fedezetet'. Ha a nem realizált nyereség/veszteség nő, a rendelkezésre álló fedezet is nő, és fordítva.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Számlaegyenleg - (Felhasznált fedezet) + (nem realizált nyereség/veszteség - díjak - finanszírozási kamatok)",
  "注:可继续用于开仓的保证金。":
    "Megjegyzés: Fedezet, amely új pozíciók nyitásához áll rendelkezésre.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Számlaegyenleg + (nem realizált nyereség/veszteség - díjak - finanszírozási kamatok)",
  "注:当前的资金结余。": "Megjegyzés: Aktuális egyenleg.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "A határidős számla teljes egyenlegére utal, beleértve a zárolt összegeket is.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Megjegyzés: Minél magasabb a kockázati ráta, annál alacsonyabb a kockázat, és fordítva.",
  该功能尚未开发: "Ez a funkció még fejlesztés alatt áll",
  重置密码: "Jelszó visszaállítása",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Adjon meg 8-20 karaktert, beleértve betűket, számokat és speciális karaktereket",
  修改成功: "Sikeres módosítás",
  输入验证码: "Adja meg az ellenőrző kódot",
  输入密码: "Adja meg a jelszót",
  详情说明: "Részletek",
  已售罄: "Elfogyott",
  剩余期限: "Hátralévő futamidő",
  限期: "Futamidő",
  闪兑货币选择: "Pénznem kiválasztása gyorsváltáshoz",
  地区选择: "Régió kiválasztása",
  "搜索国家/地区": "Ország/régió keresése",
  "身份信息已提交，将在*小时内审核完成":
    "A személyazonossági adatokat elküldtük. A feldolgozás * óráig tart.",
  "选择国家/地区": "Válasszon országot/régiót",
  "止盈价格需高于*": "A take-profit árnak magasabbnak kell lennie, mint *",
  "止损价格需低于*": "A stop-loss árnak alacsonyabbnak kell lennie, mint *",
  "止盈价格需低于*": "A take-profit árnak alacsonyabbnak kell lennie, mint *",
  "止损价格需高于*": "A stop-loss árnak magasabbnak kell lennie, mint *",
  教程详情: "Útmutató részletei",
  请输入止损价: "Adja meg a stop-loss árat",
  活期: "Rugalmas",
  赎回后立即到账: "Azonnali jóváírás visszaváltás után",
  赎回: "Visszaváltás",
  赎回理财: "Pénzügyi termék visszaváltása",
  是否赎回当前的理财订单: "Visszaváltja a jelenlegi pénzügyi termék rendelést?",
  维护: "Karbantartás",
  "系统正在维护中……": "A rendszer karbantartás alatt áll...",
  合约: "Határidős",
  闪电兑换: "Gyorsváltás",
  流水挖矿: "Volumen bányászat",
  邀请豪礼: "Meghívási bónusz",
  计算器: "Kalkulátor",
  最新价: "Legutóbbi ár",
  涨跌幅: "Változás (24h)",
  关注币种添加自选: "Kriptovaluta hozzáadása a kedvencekhez",
  一键添加自选: "Kedvencekhez adás (egy kattintás)",
  全标已读: "Összes olvasottnak jelölése",
  无消息: "Nincs üzenet",
  "暂时还没有收到任何消息通知哦!": "Még nem kapott egyetlen értesítést sem!",
  没有更多数据: "Nincs több adat",
  闪兑: "Gyorsváltás",
  从: "Ebből",
  "可用余额：": "Rendelkezésre álló egyenleg:",
  至: "EbBE",
  预览兑换结果: "Csere eredmény előnézete",
  闪兑规则: "Gyorsváltási szabályok",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "A gyorsváltás a piaci ingadozások hatálya alá esik. A ténylegesen megkapott összeg a mérvadó.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Az árfolyamokat harmadik fél határozza meg. A költségek és ingadozások miatt az árfolyam eltérhet a piaci árfolyamtól. Ellenőrizze alaposan.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "A platform körülbelül *% díjat számít fel cserénként a tőzsdei költségek fedezésére.",
  确认汇兑: "Csere megerősítése",
  您预估得到: "Becsült megszerzés",
  汇兑: "Csere",
  汇兑比例: "Árfolyam",
  刷新: "Frissítés",
  兑换: "Csere",
  没有更多了: "Nincs több adat",
  搜索币种: "Kriptovaluta keresése",
  可用: "Rendelkezésre áll",
  我知道了: "Megértettem",
  最新价格: "Legutóbbi ár",
  确认: "Megerősítés",
  最大: "Maximum",
  "风险率(%)": "Kockázati ráta (%)",
  当前委托: "Aktuális megbízások",
  合作交易历史记录: "Partner tranzakció előzmények",
  重置: "Visszaállítás",
  余额: "Egyenleg",
  现货账户: "Spot számla",
  合约账户: "Határidős számla",
  WIN账户: "WIN számla",
  赏金账户: "Jutalom számla",
  总资产折合: "Összes eszköz (USDT-ben)",
  今日收益: "Mai hozam",
  充币: "Befizetés",
  提币: "Kivétel",
  账户权益: "Számlaérték",
  "数量/类别": "Mennyiség/Kategória",
  全部币种: "Minden kriptovaluta",
  全部类型: "Minden típus",
  账单信息: "Számla információk",
  理财赎回: "Pénzügyi termék visszaváltása",
  购买理财: "Pénzügyi termék vásárlása",
  收入: "Bevételek",
  支出: "Kiadások",
  到: "-ra/-re",
  资产划转: "Eszköz átvezetés",
  "最少*": "Minimum *",
  "可用资产：": "Rendelkezésre álló eszközök:",
  确认划转: "Átvezetés megerősítése",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Az eszközöket a megfelelő számlára kell átvezetnie a kereskedéshez. A számlák közötti átvezetések díjmentesek.",
  币种账户选择: "Kriptovaluta számla kiválasztása",
  选择账户: "Számla kiválasztása",
  划转详情: "Átvezetés részletei",
  划转明细: "Átvezetés specifikációja",
  收入账单: "Bevételi számla",
  支出账单: "Kiadási számla",
  金额: "Összeg",
  总收益: "Teljes hozam",
  佣金: "Jutalék",
  用户名: "Felhasználónév",
  "已领取：": "Átvett:",
  "未领取：": "Nem vették át:",
  "请选择国家/地区": "Válasszon országot/régiót",
  请上传身份信息: "Töltse fel személyazonossági adatait",
  请选择证件类型: "Válassza ki a dokumentum típusát",
  请填写证件编码: "Adja meg a dokumentum számát",
  请填写名字: "Adja meg a keresztnevét",
  请填写姓氏: "Adja meg a vezetéknevét",
  投资金额: "Befektetési összeg",
  天: "nap",
  请输入手机号: "Adja meg telefonszámát",
  搜索: "Keresés",
  搜索历史: "Keresési előzmények",
  热门推荐: "Népszerű ajánlások",
  "《Xspace Earn协议》": "Xspace Earn protokoll",
  我已了解并同意: "Megértettem és elfogadom",
  协议: "Protokoll",
  Xspace官方中文交流群: "Xspace hivatalos kínai közösség",
  Xspace官方英文交流群: "Xspace hivatalos angol közösség",
  预计维护至: "Várható karbantartás eddig:",
  更多功能: "További funkciók",
  下载APP: "Alkalmazás letöltése",
  理财: "Pénzügyi termék",
  推荐: "Ajánlott",
  Telegram官方中文频道: "Hivatalos Telegram csatorna (kínai)",
  Telegram官方英文频道: "Hivatalos Telegram csatorna (angol)",
  官方邮箱: "Hivatalos e-mail cím",
  客服邮箱: "Ügyfélszolgálati e-mail cím",
  上述信息最终解释权归官方所有:
    "A fenti információk a platform hivatalos értelmezése alá esnek.",
  IOS版下载: "Letöltés iOS-re",
  Android版下载: "Letöltés Androidra",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Tranzakciós díj = Vásárlási díj + Finanszírozási ráta + Eladási díj",
  资金划转: "Pénzeszközök átvezetése",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatikus zárás",
  委托挂单: "Nyitott megbízás",
  买: "Vétel",
  卖: "Eladás",
  "买入/做多": "Vétel/Long",
  "卖出/做空": "Eladás/Short",
  详情: "Részletek",
  浮动涨跌: "Nem realizált nyereség/veszteség",
  最小: "Minimum",
  充币数量: "Befizetés mennyisége",
  请输入充币数量: "Adja meg a befizetés mennyiségét",
  支付截图: "Fizetési igazolás",
  提交: "Beküldés",
  上传驾驶证: "Vezetői engedély feltöltése",
  上传护照: "Útlevél feltöltése",
  加载中: "Betöltés...",
  上传成功: "Sikeres feltöltés",
  充值历史: "Befizetési előzmények",
  合约卖出手续费: "Határidős eladási díj",
  合约买入手续费: "Határidős vásárlási díj",
  系统加款: "Rendszer jóváírás",
  系统减款: "Rendszer terhelés",
  合约资金费率: "Határidős finanszírozási ráta",
  佣金分成: "Jutalék megosztás",
  U本位合约: "USDT fedezetű határidős",
  资产管理: "Eszközkezelés",
  APP下载: "Alkalmazás letöltése",
  全球领先的数字理财平台: "Világ vezető digitális vagyonkezelő platformja",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Kereskedjen azonnal Bitcoinnal, Ethereummal és több száz más digitális eszközzel",
  "24H涨跌幅": "24 órás változás",
  查看更多行情: "További piacok megtekintése",
  近24小时成交量: "24 órás forgalom",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Több száz spot és határidős párt kínál. Több mint 20 millió felhasználó 200+ országban. Világvezető digitális eszköz szolgáltatási platform.",
  用户国家分布: "Felhasználók ország szerint",
  用户数: "Felhasználók száma",
  交易对: "Kereskedési párok",
  服务支持: "Támogatás",
  "随时随地，多平台终端交易": "Kereskedjen bárhol többplatformos támogatással",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Több eszközzel kompatibilis minden kereskedési igényhez.",
  随时查看实时行情: "Valós idejű árak megtekintése bárhol",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Könnyedén vásároljon és adjon el BTC-t, ETH-t, DOGE-t és más digitális eszközöket",
  获取您关注的加密货币价格变化预警:
    "Kapjon árfolyamriasztásokat a figyelt kriptovalutákról",
  "查看比特币现货、期货、期权价格":
    "Tekintse meg a Bitcoin spot, határidős és opciós árait",
  比较各交易所加密货币价格:
    "Hasonlítsa össze a kriptovaluták árait a tőzsdék között",
  开启您的数字货币之旅: "Indítsa el útját a digitális eszközökkel",
  快捷购买数字货币: "Gyorsan vásároljon kriptovalutákat",
  "使用多种支付方式交易数字货币，安全快捷":
    "Kereskedjen biztonságosan és gyorsan több fizetési móddal",
  最优的交易费率: "A legjobb tranzakciós díjak",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Kedvező díjak, versenyképes VIP előnyök és a legjobb minőségű szolgáltatás.",
  可信赖的安全保障: "Megbízható biztonság",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Fejlett biztonsági intézkedések és a SAFU alap védi eszközeit a kockázatoktól.",
  交易: "Kereskedés",
  币币市场: "Spot piac",
  "24H成交量": "24 órás forgalom",
  交易所: "Tőzsde",
  "24H最高": "24 órás csúcs",
  "24H最低": "24 órás mélypont",
  永续合约: "Perpetual határidős",
  日涨跌: "Napi változás",
  交易深度: "Megbízási könyv mélysége",
  "资产(合约)": "Eszközök (Határidős)",
  历史仓位: "Pozíció előzmények",
  兑换记录: "Csere előzmények",
  类型: "Típus",
  充值记录: "Befizetési előzmények",
  划转记录: "Átvezetési előzmények",
  类别: "Kategória",
  历史账单: "Számla előzmények",
  在线充值: "Online befizetés",
  安全设置: "Biztonsági beállítások",
  用于账户登录使用: "A számlára való bejelentkezéshez használatos",
  用户提现时安全验证使用: "A biztonsági ellenőrzéshez használatos kivételeknél",
  验证: "Ellenőrzés",
  万: "millió",
  随时随地开启交易: "Kezdje el a kereskedést bárhol",
  "*货币交易所的所有功能尽在你的手中。":
    "A * kriptotőzsde összes funkciója a keze ügyében.",
  "下载*货币交易所APP。": "Töltse le a * kriptotőzsde alkalmazását.",
  下载自: "Letöltés innen:",
  内测版: "Béta verzió",
  下载: "Letöltés",
  扫码下载: "Scan a letöltéshez",
  设置您的资产密码: "Állítsa be eszközjelszavát",
  法币: "Fiat",
  我要买: "Vásárolni szeretnék",
  我要卖: "Eladni szeretnék",
  请输入金额: "Adja meg az összeget",
  汇率: "Árfolyam",
  获得: "Kap",
  支付通道: "Fizetési csatorna",
  收款通道: "Fogadási csatorna",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Eladáskor győződjön meg róla, hogy a fogadási csatorna az Ön nevére szól.",
  当前法币暂不支持交易对可尝试前往提现:
    "Ez a fiat pár jelenleg nem támogatott. Próbáljon kivételt.",
  前往提现: "Ugrás a kivételhez",
  该法币暂无通道: "Ehhez a fiat pénznemhez nem áll rendelkezésre csatorna",
  "正在出售中，请耐心等待": "Eladás folyamatban, kérem várjon",
  请选择支付通道: "Válasszon fizetési csatornát",
  请选择方式: "Válasszon módot",
  法币历史: "Fiat előzmények",
  买币: "Kriptó vásárlás",
  卖币: "Kriptó eladás",
  失败: "Sikertelen",
  已完成: "Befejezve",
  未付款: "Nem fizetett",
  待审核: "Függőben",
  打款中: "Kifizetés folyamatban",
  订单详情: "Rendelés részletei",
  联系客服: "Kapcsolatfelvétel az ügyfélszolgálattal",
  到账金额: "Megkapott összeg",
  通道: "Csatorna",
  收款人: "Kedvezményezett",
  收款账户: "Kedvezményezett számlája",
  "订单出售失败，请查下方失败原因":
    "A rendelés eladása sikertelen. Lásd alább a sikertelenség okát.",
  失败原因: "A sikertelenség oka",
  您还未进行付款: "Még nem fizetett",
  您已成功购买: "A vásárlás sikeres volt",
  已取消订单: "Rendelés visszavonva",
  "订单正在审核中，请耐心等待":
    "A rendelés feldolgozás alatt áll. Kérem várjon.",
  您已成功出售: "Az eladás sikeres volt",
  "订单正在打款中，请耐心等待": "A kifizetés folyamatban van. Kérem várjon.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "A fizetéshez másik platformra kell navigálnia. Ügyeljen adatainak biztonságára.",
  当前法币暂不支持交易对可尝试前往充值:
    "Ez a fiat pár jelenleg nem támogatott. Próbáljon befizetést.",
  前往充值: "Ugrás a befizetéshez",
  购买: "Vásárlás",
  订单号: "Rendelésszám",
  单价: "Egységár",
  到账数量: "Megkapott mennyiség",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Van egy nem fizetett rendelés. Szeretne új fizetési megbízást indítani?",
  继续支付: "Fizetés folytatása",
  重新下单: "Új rendelés",
  是否确定出售: "Biztosan el kívánja adni?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "A megerősítés után a platform vevőt rendel a megbízáshoz. Várja meg a párosítást.",
  出售: "Eladás",
  收款方式: "Fogadási mód",
  订单已生成: "Rendelés létrehozva",
  取消订单: "Rendelés visszavonása",
  请在: "Kérem ennyi időn belül:",
  内完成付款: "végezze el a fizetést",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Hagyja el a platformot, jelentkezzen be a választott fizetési módjába, és utalja át az összeget az eladó alábbi számlájára. Feltétlenül tüntesse fel a hivatkozást:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Hivatkozás nélkül az eladó nem tudja megerősíteni a fizetést, ami eszközveszteséghez vezethet.",
  "未在规定的时间内付款，订单都将被取消。":
    "Ha nem fizet a megadott időn belül, a rendelés visszavonásra kerül.",
  姓名: "Név",
  收款姓名: "Kedvezményezett neve",
  开户支行: "Bankfiók",
  银行卡号: "Bankkártyaszám",
  "付款后，返回本平台": "Fizetés után térjen vissza erre a platformra",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Kattintson az alábbi 'Befejeztem a fizetést, értesítsd az eladót' gombra",
  未点击卖家不会放款:
    "Az eladó csak a gombra kattintás után adja ki a kriptovalutát",
  交易条款: "Tranzakciós feltételek",
  "购买资金来源，必须合法安全的资金，方可交易":
    "A vásárláshoz használt forrásoknak legálisnak és biztonságosnak kell lenniük",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Csalás, piramisjáték, szerencsejáték vagy más illegális források nem engedélyezettek",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Ha a tranzakció után a források zárolásra kerülnek vagy gyanúsak, nem adjuk ki az USDT-t, és visszatérítést adunk",
  "已付款，通知卖家": "Fizetve, értesítsd az eladót",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Ha ma összesen * rendelést von vissza, a napi vásárlási joga visszavonásra kerül. Biztosan visszavonja ezt a rendelést?",
  添加收款方式: "Fogadási mód hozzáadása",
  是否删除此收款方式: "Törli ezt a fogadási módot?",
  删除: "Törlés",
  请选择法币: "Válasszon fiat pénznemet",
  机构名称: "Intézmény neve",
  请选择机构: "Válasszon intézményt",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "A kiválasztott fogadási módja megjelenik a vevők számára, amikor kriptovalutát ad el. Győződjön meg róla, hogy az adatok helyesek.",
  请选择银行: "Válasszon bankot",
  请输入姓名: "Adja meg a nevét",
  账号: "Számlaszám",
  请输入账号: "Adja meg a számlaszámot",
  收款码: "Fogadási kód",
  "银行账号/卡号": "Bankszámlaszám/Kártyaszám",
  "请输入银行账号/卡号": "Adja meg a bankszámlaszámát/kártyaszámát",
  "开户支行（选填）": "Bankfiók (opcionális)",
  请输入开户支行: "Adja meg a bankfiókot",
  "加入*官方频道": "Csatlakozzon a hivatalos * csatornához",
  关于: "Rólunk",
  条款: "Feltételek",
  成功: "Sikeres",
  等待: "Várakozás",
  作废: "Érvénytelen",
  确认付款: "Fizetés megerősítése",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Fizetés befejeződött? A megerősítés után az eladó * percen belül megerősíti a kézhezvételt.",
  最大金额: "Maximális összeg",
  最小金额: "Minimális összeg",
  付款: "Fizetés",
  法币充值: "Fiat befizetés",
  法币提现: "Fiat kivétel",
  待支付: "Fizetésre vár",
  已支付: "Fizetve",
  商户名: "Eladó neve",
  当前没有添加支付方式: "Nincs fizetési mód hozzáadva",
  添加后再出售: "Adjon hozzá egyet az eladás előtt",
  新人大礼包: "Üdvözlő csomag",
  注册即可领取: "Regisztráció után kapja meg",
  立即领取: "Azonnali átvétel",
  不再提示: "Ne jelenjen meg újra",
  "该奖励需在APP中领取，请下载APP":
    "Ezt a jutalmat csak az alkalmazásban lehet átvenni. Töltse le az alkalmazást.",
  去交易: "Ugrás a kereskedéshez",
  期权交易: "Opciós kereskedés",
  交易额: "Kereskedési összeg",
  可用额度: "Rendelkezésre álló keret",
  交易周期: "Kereskedési időszak",
  看涨: "Emelkedés (Call)",
  看跌: "Csökkenés (Put)",
  看空: "Short",
  当前持有: "Jelenlegi pozíció",
  胜率: "Nyert arány",
  "盈利/亏损数": "Nyereséges/veszteséges tranzakciók száma",
  累计实现盈亏: "Realizált teljes nyereség/veszteség",
  秒: "másodperc",
  分: "perc",
  小时: "óra",
  周: "hét",
  下单时间: "Rendelés ideje",
  剩余时间: "Hátralévő idő",
  买入价: "Vételár",
  结算价: "Elszámolási ár",
  实现盈利: "Realizált nyereség",
  结算时间: "Elszámolás ideje",
  期权: "Opció",
  新手教程: "Kezdő útmutató",
  我的订单: "Rendeléseim",
  赔率: "Szorzó",
  全部订单: "Összes rendelés",
  持有订单: "Nyitott rendelések",
  历史订单: "Rendelési előzmények",
  输入交易额度: "Adja meg a kereskedési összeget",
  选择交易周期: "Válasszon kereskedési időszakot",
  去注册: "Regisztráció",
  冻结: "Zárolás",
  期权支出: "Opciós kiadás",
  期权收入: "Opciós bevétel",
  用户提现: "Felhasználói kivétel",
  "是否购买？": "Megvásárolja ezt az opciót?",
  购买成功: "Sikeres vásárlás",
  请签名: "Kérem, írja alá",
  提交签名: "Aláírás beküldése",
  清空签名: "Aláírás törlése",
  签名审核中: "Aláírás feldolgozás alatt",
  已提交: "Beküldve",
  扫一扫下载APP: "Scan a letöltéshez",
  新手领取大礼包: "Új felhasználói üdvözlő csomag",
  注册实名即送彩金:
    "Regisztráljon és igazolja személyazonosságát a bónusz megszerzéséhez",
  交易总额: "Teljes kereskedési volumen",
  资产不足: "Nem elegendő eszköz",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Nem elegendő eszköz a WIN számlán. Átvezethet eszközöket a főszámlájáról.",
  Win: "WIN",
  比赛: "Verseny",
  未开始: "Nem kezdődött el",
  赛程: "Menetrend",
  赛果: "Eredmény",
  已结束: "Befejeződött",
  让球: "Handicap",
  进球数: "Gólok",
  大: "Több",
  小: "Kevesebb",
  胜负平: "1X2 (Győzelem/Döntetlen/Vereség)",
  和局: "Döntetlen",
  投注: "Tét",
  下注金额: "Tét összege",
  下注: "Fogadás",
  阵容: "Felállás",
  分析: "Elemzés",
  输入下注金额: "Adja meg a tét összegét",
  下注成功: "Sikeres fogadás",
  投注记录: "Fogadási előzmények",
  未结算: "Nincs elszámolva",
  已结算: "Elszámolva",
  流水: "Forgalom",
  输赢: "Nyereség/Veszteség",
  赛时: "Mérkőzés ideje",
  下注时间: "Fogadás ideje",
  足彩竞猜: "Labdarúgó tippmix",
  查看详情: "Részletek megtekintése",
  输: "Veszteség",
  赢: "Nyereség",
  主: "Hazai",
  客: "Vendég",
  主胜: "Hazai győzelem",
  客胜: "Vendég győzelem",
  平: "Döntetlen",
  已延期: "Elhalasztva",
  账号异常: "Számla rendellenesség",
  全场独赢: "Teljes idő 1X2",
  全场让球: "Teljes idő Handicap",
  全场大小: "Teljes idő Több/Kevesebb",
  总进球: "Összes gól",
  拍摄照片要求: "Fényképezési követelmények",
  标准拍摄: "Normál fénykép",
  边框缺失: "Hiányzó keret",
  照片模糊: "Elmosódott fénykép",
  闪光强烈: "Túl erős vaku",
  上传手持证件照: "Fénykép feltöltése dokumentummal a kézben",
  上传证件照: "Dokumentum fényképének feltöltése",
  换一张: "Új fénykép",
  出生日期: "Születési dátum",
  请选择出生日期: "Válassza ki a születési dátumot",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Adja meg az alábbi ellenőrző kódot a regisztrációhoz szükséges e-mail kód megszerzéséhez.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Még * hitelesítési kísérlete maradt. A határ túllépése után nem tudja hitelesíteni magát.",
  上半场: "1. félidő",
  下半场: "2. félidő",
  独赢: "1X2",
  上半场独赢: "1. félidő 1X2",
  下半场独赢: "2. félidő 1X2",
  上半场让球: "1. félidő Handicap",
  下半场让球: "2. félidő Handicap",
  上半场大小球: "1. félidő Több/Kevesebb",
  下半场大小球: "2. félidő Több/Kevesebb",
  波胆: "Pontos végeredmény",
  上半场波胆: "1. félidő Pontos végeredmény",
  下半场波胆: "2. félidő Pontos végeredmény",
  单双: "Páratlan/Páros",
  单: "Páratlan",
  双: "Páros",
  上半场单双: "1. félidő Páratlan/Páros",
  下半场单双: "2. félidő Páratlan/Páros",
  上半场总进球: "1. félidő Összes gól",
  下半场总进球: "2. félidő Összes gól",
  中场: "Félidő",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Megjegyzés: A kézben tartott dokumentumról készült fényképhez írja a szöveget egy fehér papírra, és fényképezze le együtt a dokumentumával, a példa szerint.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Sok csaló számlát találtak a közelmúltban, és büntetést kaptak. Forduljon az ügyfélszolgálathoz, ha úgy érzi, hogy számláját tévesen büntették meg.",
  最小下注金额: "Minimális tét",
  参与活动最小下注金额: "Minimális tét az eseményen való részvételhez",
  记住密码: "Jelszó megjegyzése",
  比分: "Eredmény",
  "您还未登录，请先登录": "Nem jelentkezett be. Először jelentkezzen be.",
  立即登录: "Bejelentkezés most",
  下注限额: "Tétkeret",
  可赢金额: "Megnyerhető összeg",
  闪兑详情: "Gyorsváltás részletei",
  大小球: "Több/Kevesebb",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Az árfolyamingadozások miatt a végső tét összege eltérhet. A rendelés a mérvadó.",
  开赛时间: "Kezdési idő",
  足球收入: "Labdarúgás bevételek",
  足球支出: "Labdarúgás kiadások",
  活动详情: "Esemény részletei",
  为世界杯喝彩: "Támogassa a világbajnokságot",
  我的竞猜: "Tippjeim",
  "竞猜比赛、有机会瓜分*USDT":
    "Tippeljen a mérkőzésekre, és nyerje meg * USDT egy részét",
  "瓜分*USDT": "Ossza el * USDT-t",
  距离活动结束还有: "Az esemény végéig hátralévő idő:",
  我的门票: "Jegyeim",
  竞猜结束时间: "Tippelés vége",
  猜比分: "Eredmény tippelés",
  "福利派送中，完成任务即可获取门票":
    "Bónuszok kiosztás alatt. Teljesítse a feladatokat a jegyek megszerzéséhez.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Teljesítse az alábbi feladatokat a megfelelő számú jegy megszerzéséhez a versenyen való részvételhez.",
  时: "óra",
  活动: "Esemény",
  竞猜记录: "Tippelési előzmények",
  结果: "Eredmény",
  任务: "Feladat",
  去邀请: "Meghívás",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tippelje meg minden mérkőzés eredményét, és nyerje meg $* egy részét.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "A tippeléshez jegy szükséges. A jegyeket a platform feladatainak teljesítésével lehet megszerezni.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Sikeres tippelés után küldje el a képernyőképet az ügyfélszolgálatnak. Jóváírják a bónuszt a számláján, amelyet azonnal kivehet.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "A csalás tilos. Ha kiderül, a jutalom érvénytelenné válik.",
  "完成任务后，点击咨询客服获得门票。":
    "A feladatok teljesítése után kattintson az 'Ügyfélszolgálat felkeresése' gombra a jegyek megszerzéséhez.",
  继续猜: "Tippelés folytatása",
  总单数: "Fogadások száma összesen",
  赛事筛选: "Szűrés esemény szerint",
  球队筛选: "Szűrés csapat szerint",
  总金额: "Teljes összeg",
  总流水: "Teljes forgalom",
  派奖金额: "Kiosztott bónusz összege",
  下注单数: "Fogadások száma",
  利润: "Nyereség",
  更多福利: "További bónuszok",
  我的奖金: "Bónuszom",
  未认证: "Nem hitelesített",
  总量: "Összesen",
  或: "vagy",
  模拟交易: "Demo kereskedés",
  体验账户不可操作: "Nem elérhető demo számlán",
  世界杯比分竞猜: "VB eredmény tippelés",
  "领*USDT起": "Kapjon * USDT-tól",
  消息: "Üzenetek",
  滚球: "Élő fogadás",
  是: "Igen",
  不是: "Nem",
  当前余额: "Jelenlegi egyenleg",
  KOL招募: "KOL toborzás",
  本月净输赢: "Nettó nyereség/veszteség ebben a hónapban",
  本月佣金: "Jutalék ebben a hónapban",
  佣金比例: "Jutalék százalék",
  活跃人数: "Aktív felhasználók",
  新增下级: "Új alsóbb szintek",
  登录人数: "Bejelentkezett felhasználók",
  首存人数: "Első befizetést teljesítők",
  数据分析: "Adatelemzés",
  人数: "Fő",
  新注册存款金额: "Új regisztrációk befizetési összege",
  老用户存款金额: "Meglévő felhasználók befizetési összege",
  首存金额: "Első befizetés összege",
  快捷入口: "Gyors elérés",
  成员管理: "Tagkezelés",
  财务报表: "Pénzügyi kimutatások",
  分红报表: "Osztalék jelentés",
  订单记录: "Rendelési előzmények",
  VIP专享: "VIP exkluzív",
  推广工具: "Promóciós eszközök",
  计算规则: "Számítási szabályok",
  账变明细: "Tranzakció részletei",
  成员: "Tagok",
  下级概览: "Alsóbb szintek áttekintése",
  下级成员总计: "Alsóbb szintek összesen",
  本月新增: "Új ebben a hónapban",
  本月活跃会员: "Aktív tagok ebben a hónapban",
  今日活跃会员: "Aktív tagok ma",
  本月有效活跃: "Hatékonyan aktív ebben a hónapban",
  活跃成员占比: "Aktív tagok aránya",
  本月活跃: "Aktív ebben a hónapban",
  今日活跃: "Aktív ma",
  下级成员: "Alsóbb szintek",
  会员账号: "Tagszámla",
  统计时间: "Statisztika ideje",
  筛选: "Szűrés",
  存款: "Befizetés",
  取款: "Kivétel",
  总输赢: "Teljes nyereség/veszteség",
  是否有效用户: "Aktív felhasználó?",
  最近登录时间: "Utolsó bejelentkezés",
  否: "Nem",
  开始时间: "Kezdési idő",
  结束时间: "Befejezési idő",
  提取: "Kivétel",
  总盈亏: "Teljes eredmény",
  净盈亏: "Nettó eredmény",
  分红: "Osztalék",
  概览: "Áttekintés",
  月度详细数据: "Havi részletes adatok",
  未发放: "Nem kiosztott",
  活跃用户: "Aktív felhasználók",
  有效新增会员: "Hatékony új tagok",
  冲正后净输赢: "Nettó nyereség/veszteség korrekció után",
  上月结余: "Előző havi egyenleg",
  净输赢: "Nettó nyereség/veszteség",
  "系统每日新加坡时间1:00更新一次报表":
    "A jelentések naponta 01:00 szingapúri idő szerint frissülnek.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "A jelentésekben a pozitív számok a partner nyereségét, a negatív számok a partner veszteségét jelentik.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "A jutalékadatok naponta frissülnek, tájékoztató jellegűek, és nem képezik a tényleges jutalékfizetés alapját.",
  选择时间: "Időválasztás",
  足球: "Labdarúgás",
  投注金额: "Tét összege",
  有效订单: "Érvényes rendelések",
  下级账户: "Alsóbb szintű számla",
  待成交: "Függőben",
  下单金额: "Rendelés összege",
  订单内容: "Rendelés tartalma",
  秒数: "Másodpercek",
  联赛: "Bajnokság",
  队伍: "Csapat",
  比赛时间: "Mérkőzés ideje",
  玩法: "Fogadás típusa",
  等级规则表: "Szintszabály táblázat",
  等级: "Szint",
  活跃会员: "Aktív tagok",
  最新活跃: "Legutóbbi aktivitás",
  额外佣金: "Extra jutalék",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Havonta a növekedési szabványok alapján. Csak egy szint előnyeit élvezheti.",
  渠道生成: "Csatorna generálás",
  创建: "Létrehozás",
  渠道名称: "Csatorna neve",
  注册人数: "Regisztrációk száma",
  浏览人数: "Megtekintések száma",
  构建状态: "Építési állapot",
  禁用: "Letiltás",
  启用: "Engedélyezés",
  查看: "Megtekintés",
  创建渠道: "Csatorna létrehozása",
  创建成功: "Sikeres létrehozás",
  操作成功: "Sikeres művelet",
  渠道详情: "Csatorna részletei",
  邀请码: "Meghívókód",
  访问人数: "Látogatók száma",
  渠道地址: "Csatorna címe",
  我的福利: "Bónuszaim",
  充值福利: "Befizetési bónusz",
  当前流水: "Aktuális forgalom",
  如何参与: "Hogyan vegyek részt",
  币种充值: "Kriptovaluta befizetés",
  充值福利中领取福利: "Bónusz átvétele a befizetési bónusznál",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Szabály: A befizetési bónusz önkéntes, a befizetést követő 24 óráig érvényes. Átvétel után a kivétel ideiglenesen zárolásra kerül, amíg a forgalmi követelmény teljesül.",
  失效日期: "Lejárati dátum",
  "暂无福利领取，充值后领取": "Nincs elérhető bónusz. Befizetés után vegye át.",
  参与: "Részvétel",
  充值赠送: "Befizetési bónusz",
  "领取*%的赠送": "*% bónusz átvétele",
  去领取: "Átvétel",
  VIP奖励: "VIP jutalom",
  "当前可领取*USDT，是否确认领取":
    "* USDT áll rendelkezésre átvételre. Megerősíti?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Átvétel után a kivétel ideiglenesen zárolásra kerül, amíg a forgalom el nem éri a * USDT-t.",
  充值送大礼: "Befizetési ajándék",
  "存入越多，送越多！": "Minél többet fizet be, annál nagyobb ajándékot kap!",
  无效: "Érvénytelen",
  有效: "Érvényes",
  总存金额: "Teljes befizetett összeg",
  提示: "Megjegyzés",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "A pozitív számok a teljes és nettó nyereségben/veszteségben platformnyereséget jelentenek. A napi adatok tájékoztató jellegűek.",
  "净盈亏：总盈亏-用户返水":
    "Nettó eredmény: Teljes eredmény - Visszatérítés a felhasználónak",
  盈利方: "Nyereséges fél",
  代理: "Ügynök",
  客户: "Ügyfél",
  平局: "Döntetlen",
  平台: "Platform",
  "已提交审核，请耐心等待": "Hitelesítésre beküldve. Kérem várjon.",
  充值日期: "Befizetés dátuma",
  平台本月总输赢: "Platform teljes nyeresége/vesztesége ebben a hónapban",
  KOL招募合作: "KOL toborzási együttműködés",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "A platform megnyitja a KOL toborzást. Egy közösségi média fiókkal osztozhat az osztalékban az egyszeri ügyfélszerzés után, és életre szóló jövedelmet élvezhet.",
  级别: "Szint",
  平台利润返佣: "Platform nyereség jutalék",
  佣金案例: "Jutalék példa",
  交易项目: "Kereskedési termékek",
  "期权交易、合约交易、足球游戏":
    "Opciós kereskedés, határidős kereskedés, labdarúgó játékok",
  报名方式: "Jelentkezési mód",
  点击KOL招募报名: "Kattintson a KOL toborzásra való jelentkezéshez",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Üdvözöljük csapatunkban. Támogatjuk Önt saját felhasználói rendszerének kiépítésében. Keressen akár *% jutalékot. Várjuk részvételét.",
  输入联系方式: "Adja meg elérhetőségeit",
  最低活跃人数: "Minimális aktív felhasználók száma",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Pl.: Ha az aktív felhasználók száma ebben a hónapban ≥ * és a platform teljes nyeresége/vesztesége ≥ * USDT, akkor Ön * szintbe tartozik, és *% jutalékot kap.",
  比分竞猜: "Eredmény tippelés",
  豪礼相赠: "Nagy ajándék",
  足球活动: "Labdarúgó esemény",
  圣诞节活动: "Karácsonyi esemény",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Részt vett egy eseményen. A kivétel ideiglenesen zárolva van. Még * USDT forgalomra van szüksége a feloldáshoz.",
  剩余流水: "Hátralévő forgalom",
  助力足球: "Támogassa a labdarúgást",
  佣金累计: "Jutalék összesen",
  有效投注: "Érvényes fogadások",
  今日: "Ma",
  今日返水: "Napi visszatérítés",
  VIP返水: "VIP visszatérítés",
  返水记录: "Visszatérítési előzmények",
  成员信息: "Tag információk",
  基本信息: "Alapvető információk",
  钱包余额: "Tárca egyenleg",
  投注信息: "Fogadási információk",
  返水: "Visszatérítés",
  总下注: "Teljes tét",
  今日输赢: "Mai nyereség/veszteség",
  下注动态: "Fogadási aktivitás",
  返水奖励: "Visszatérítési jutalom",
  分红金额: "Osztalék összege",
  返水支出: "Visszatérítési kiadás",
  总返水: "Teljes visszatérítés",
  流水总额: "Teljes forgalom",
  返水总额: "Teljes visszatérítés",
  返水详情: "Visszatérítés részletei",
  日流水: "Napi forgalom",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "A platform további visszatérítést biztosít az alsóbb szintjei napi forgalma alapján. A jutalom kifizetése naponta 00:00 szingapúri idő szerint a jutalomszámlára történik.",
  "申请成功，等待审核": "Kérelem sikeres, hitelesítésre vár",
  "我出本金，盈利共分享": "Én adom a tőkét, a nyereséget megosztjuk",
  最高分红: "Maximális osztalék",
  投资大师比赛: "Mesterbefektető verseny",
  "我出本金，你盈利": "Én adom a tőkét, te nyersz",
  共分享: "Közös megosztás",
  最高分红可得: "Maximális elérhető osztalék",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exkluzív üdvözlő bónusz: $* ingyen. Átvétel után befektethet bármely projektbe. A nyereség azonnal kivehető.",
  报名领取: "Jelentkezés és átvétel",
  审核驳回: "Hitelesítés elutasítva",
  驳回原因: "Elutasítás oka",
  活动运行周期: "Esemény időtartama",
  "申请成功后起至*天内完成超额收益。":
    "Érjen el többlethozamot * napon belül a jóváhagyástól számítva.",
  分红比: "Osztalék arány",
  "*日获得盈利后，可获得*%的收益额。":
    "A * napon elért nyereség után megkapja a hozamösszeg *%-át.",
  参与条件: "Részvételi feltételek",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Oroszországból vagy Törökországból származó felhasználók, akik még nem vettek részt.",
  计算项目: "Számított termékek",
  "合约、体育、期权": "Határidős, Sport, Opciók",
  我的投资: "Befektetéseim",
  参与天数: "Részvételi napok",
  累计下注: "Összes tét",
  累计盈亏: "Teljes nyereség/veszteség",
  预计可分红: "Várható osztalék",
  常见问题: "Gyakran ismételt kérdések (GYIK)",
  什么是平台出资: "Mi az a platformfinanszírozás?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "A platform ingyenes forrásokat biztosít bizonyos országok felhasználóinak projektekbe való befektetéshez.",
  怎么获取平台出资的福利:
    "Hogyan szerezhetem meg a platformfinanszírozási bónuszt?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Ha Ön a kijelölt országok egyikéből származik, kattintson a fenti jelentkezési gombra. A jóváhagyás után * USDT kerül át a jutalomszámlájára, amelyet átvezethet befektetés céljából.",
  什么是分红: "Mi az az osztalék?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Osztalék: Ha a hozam eléri a 100%-ot a megadott időn belül, megkapja a többlethozam 50%-át. Példa: Kap 100 USDT-t, elér 120% hozamot, akkor a 20% a többlethozam.",
  "如何取得分红？": "Hogyan szerezhetek osztalékot?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Az esemény ciklusa * naponta. A befejezést követően elszámolásra kerül sor. Ha teljesíti a követelményeket, az osztalék a jutalomszámlára kerül. Ha nem, a hozamát és a platformfinanszírozást eltávolítják.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "A részt vevő számláknak KYC-hitelesítéssel kell rendelkezniük. Csak egy bónusz számlánként.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "A KYC a részvételhez csak a kijelölt országokban érvényes. Ellenőrizze, hogy az Ön országa megegyezik-e az esemény országával.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "A sikeres részvétel után a kivétel ideiglenesen zárolásra kerül, amíg az esemény be nem fejeződik.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Tartsa be az esemény szabályait. Csalás vagy rendszerhibák kihasználása esetén a számláján lévő összes pénzeszköz véglegesen zárolásra kerül.",
  平台出资: "Platformfinanszírozás",
  平台出资收回: "Platformfinanszírozás visszavonva",
  投资大师奖励: "Mesterbefektető jutalom",
  请下载APP添加收款方式:
    "Töltse le az alkalmazást a fogadási mód hozzáadásához",
  请下载APP进行身份验证:
    "Töltse le az alkalmazást a személyazonosság igazolásához",
  请下载APP参与: "Töltse le az alkalmazást a részvételhez",
  技术指标: "Technikai indikátorok",
  主图: "Fő grafikon",
  副图: "Mellék grafikon",
  新注册人数: "Új regisztrációk",
  老用户存款人数: "Meglévő felhasználók, akik befizetnek",
  存款人数: "Befizetések száma",
  取款人数: "Kivételek száma",
  投注人数: "Fogadások száma",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Kivéve Indonézia, India, Banglades felhasználói, akik még nem vettek részt.",
  市场动态: "Piaci dinamika",
  外汇合约: "Forex határidős",
  盈亏比: "Nyereség/veszteség arány",
  委托价: "Megbízás ára",
  可用余额: "Rendelkezésre álló egyenleg",
  持仓额: "Pozíció értéke",
  强平价: "Likvidációs ár",
  修改: "Módosítás",
  修改价位: "Ár módosítása",
  外汇: "Forex",
  外汇账户: "Forex számla",
  我的交易: "Tranzakcióim",
  未设置: "Nincs beállítva",
  超出最大可设数值: "Meghaladja a maximálisan beállítható értéket",
  超出最小可设数值: "A minimálisan beállítható érték alatt van",
  止盈超出最小可设数值:
    "A take-profit a minimálisan beállítható érték alatt van",
  止损超出最大可设数值:
    "A stop-loss meghaladja a maximálisan beállítható értéket",
  止盈超出最大可设数值:
    "A take-profit meghaladja a maximálisan beállítható értéket",
  止损超出最小可设数值: "A stop-loss a minimálisan beállítható érték alatt van",
  挖矿: "Bányászat",
  交易账户: "Kereskedési számla",
  买涨: "Vétel (Long)",
  买跌: "Eladás (Short)",
  请输入正确的银行卡信息: "Adja meg a helyes bankkártya adatokat",
  联系在线客服: "Kapcsolatfelvétel az élő ügyfélszolgálattal",
  法币交易请联系在线客服:
    "Fiat kereskedéssel kapcsolatban forduljon az ügyfélszolgálathoz",
  提交订单: "Rendelés leadása",
  "支付过程如有疑问,请联系在线客服":
    "Ha kérdése van a fizetési folyamattal kapcsolatban, forduljon az ügyfélszolgálathoz",
  彩金赠送: "Bónusz jóváírás",
  在线客服: "Élő chat",
  最少投资: "Minimális befektetés",
  "提交时间:": "Beküldés ideje:",
  提现拒绝: "Kivétel elutasítva",
  认证拒绝: "Hitelesítés elutasítva",
  认证通过: "Hitelesítés jóváhagyva",
  请输入正确的交易额度: "Adjon meg érvényes kereskedési összeget",
  最大下注金额: "Maximális tét",
  手机号: "Telefonszám",
  邮箱注册: "Regisztráció e-mail címmel",
  手机号注册: "Regisztráció telefonszámmal",
  查询: "Lekérdezés",
  手机号登录: "Bejelentkezés telefonszámmal",
  邮箱登录: "Bejelentkezés e-mail címmel",
  请输入数量: "Adja meg a mennyiséget",
  可用数量: "Rendelkezésre álló mennyiség",
  钱包登录: "Bejelentkezés tárcával",
  请输入正确的邀请码: "Adjon meg érvényes meghívókódot",
  "请输入邀请码(必填)": "Adja meg a meghívókódot (kötelező)",
  输入正确的金额: "Adjon meg érvényes összeget",
  法币充值: "Fiat befizetés",
  卢比充值: "Indiai rúpia befizetés",
  请输入法币: "Adja meg a fiat összeget",
  请输入IFSC: "Adja meg az IFSC kódot",
  "银行编码(选填)": "Bankkód (opcionális)",
  请输入银行编码: "Adja meg a bankkódot",
  请输入大于8位数的密码: "Adjon meg 8 karakternél hosszabb jelszót",
  添加成功: "Sikeres hozzáadás",
  "60秒": "60 másodperc",
  "180秒": "180 másodperc",
  "300秒": "300 másodperc",
  "2次密码不一致": "A jelszavak nem egyeznek",
  输入提币数量: "Adja meg a kivonási mennyiséget",
  图片格式不正确: "Érvénytelen képformátum",
  图片大于20M: "A kép nagyobb, mint 20 MB",
  请设置委托价格: "Állítson be megbízási árat",
  输入资金密码: "Adja meg az eszközjelszót",
  验证码错误: "Érvénytelen ellenőrző kód",
  充值拒绝: "Befizetés elutasítva",
  请输入SSN: "Adja meg az SSN-t",
  结算完成: "Elszámolás befejeződött",
  继续下单: "Tovább a rendeléshez",
  限价: "Limit megbízás",
  买入价格: "Vételi ár",
  买入量: "Vásárlás mennyisége",
  卖出价格: "Eladási ár",
  卖出量: "Eladás mennyisége",
  买入: "Vétel",
  卖出: "Eladás",
  订单创建成功: "Rendelés sikeresen létrehozva",
  币币买入支出: "Spot vásárlás kiadás",
  币币买入支出退还: "Spot vásárlás kiadás visszatérítése",
  币币买入获得: "Spot vásárlásból szerzett",
  币币卖出支出: "Spot eladás kiadás",
  币币卖出支出退还: "Spot eladás kiadás visszatérítése",
  币币卖出获得: "Spot eladásból szerzett",
  币币交易手续费: "Spot tranzakciós díj",
  请输入限价: "Adja meg a limitárat",
  成交: "Teljesült",
  等待成交: "Végrehajtásra vár",
  交易完成: "Tranzakció befejeződött",
  被取消: "Visszavonva",
  交易时间: "Tranzakció ideje",
  法币交易: "Fiat tranzakció",
  法币出售: "Fiat eladás",

  两次密码不一致: "A jelszavak nem egyeznek",
  再次输入账户密码: "Adja meg újra a számla jelszavát",

  美国: "Egyesült Államok",
  韩国: "Dél-Korea",
  阿尔巴尼亚: "Albánia",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikai Virgin-szigetek",
  英属处女群岛: "Brit Virgin-szigetek",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Üzbegisztán",
  乌拉圭: "Uruguay",
  英国: "Egyesült Királyság",
  阿拉伯联合酋长国: "Egyesült Arab Emírségek",
  乌克兰: "Ukrajna",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- és Caicos-szigetek",
  土库曼斯坦: "Türkmenisztán",
  土耳其: "Törökország",
  突尼斯: "Tunézia",
  特立尼达和多巴哥: "Trinidad és Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Kelet-Timor",
  泰国: "Thaiföld",
  坦桑尼亚: "Tanzánia",
  塔吉克斯坦: "Tádzsikisztán",
  中国台湾: "Tajvan",
  叙利亚: "Szíria",
  瑞士: "Svájc",
  瑞典: "Svédország",
  斯威士兰: "Szváziföld",
  苏里南: "Suriname",
  苏丹: "Szudán",
  斯里兰卡: "Srí Lanka",
  西班牙: "Spanyolország",
  南非: "Dél-Afrika",
  索马里: "Szomália",
  所罗门群岛: "Salamon-szigetek",
  斯洛文尼亚: "Szlovénia",
  斯洛伐克: "Szlovákia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (holland rész)",
  新加坡: "Szingapúr",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelle-szigetek",
  塞尔维亚: "Szerbia",
  塞内加尔: "Szenegál",
  沙特阿拉伯: "Szaúd-Arábia",
  圣多美和普林西比: "São Tomé és Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Szamoa",
  圣克里斯托弗和尼维斯: "Saint Kitts és Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent és a Grenadine-szigetek",
  圣彼埃尔和密克隆岛: "Saint-Pierre és Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts és Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Oroszország",
  罗马尼亚: "Románia",
  留尼汪: "Réunion",
  刚果共和国: "Kongói Köztársaság",
  卡塔尔: "Katar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugália",
  波兰: "Lengyelország",
  菲律宾: "Fülöp-szigetek",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Pápua Új-Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palesztina",
  帕劳: "Palau",
  巴基斯坦: "Pakisztán",
  阿曼: "Omán",
  挪威: "Norvégia",
  尼日利亚: "Nigéria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Új-Zéland",
  新喀里多尼亚: "Új-Kaledónia",
  荷属安德列斯群岛: "Holland Antillák",
  荷兰: "Hollandia",
  尼泊尔: "Nepál",
  纳米比亚: "Namíbia",
  缅甸: "Mianmar",
  莫桑比克: "Mozambik",
  摩洛哥: "Marokkó",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegró",
  蒙古: "Mongólia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexikó",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritánia",
  马里亚纳群岛: "Mariana-szigetek",
  马提尼克: "Martinique",
  马耳他: "Málta",
  马里: "Mali",
  马尔代夫: "Maldív-szigetek",
  马来西亚: "Malajzia",
  马拉维: "Malawi",
  马达加斯加: "Madagaszkár",
  马其顿: "Észak-Macedónia",
  中国澳门: "Makaó",
  卢森堡: "Luxemburg",
  立陶宛: "Litvánia",
  列支敦士登: "Liechtenstein",
  利比亚: "Líbia",
  利比里亚: "Libéria",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Lettország",
  老挝: "Laosz",
  吉尔吉斯斯坦: "Kirgizisztán",
  科威特: "Kuvait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazahsztán",
  约旦: "Jordánia",
  日本: "Japán",
  牙买加: "Jamaica",
  象牙海岸: "Elefántcsontpart",
  意大利: "Olaszország",
  以色列: "Izrael",
  爱尔兰: "Írország",
  伊拉克: "Irak",
  伊朗: "Irán",
  印度尼西亚: "Indonézia",
  印度: "India",
  冰岛: "Izland",
  匈牙利: "Magyarország",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Bissau-Guinea",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönland",
  希腊: "Görögország",
  直布罗陀: "Gibraltár",
  加纳: "Ghána",
  德国: "Németország",
  格鲁吉亚: "Grúzia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Francia Polinézia",
  法属圭亚那: "Francia Guyana",
  法国: "Franciaország",
  芬兰: "Finnország",
  斐济: "Fidzsi",
  法罗群岛: "Feröer-szigetek",
  埃塞俄比亚: "Etiópia",
  爱沙尼亚: "Észtország",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Egyenlítői-Guinea",
  萨尔瓦多: "Salvador",
  埃及: "Egyiptom",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikai Köztársaság",
  多米尼加: "Dominika",
  吉布提: "Dzsibuti",
  丹麦: "Dánia",
  捷克: "Csehország",
  塞浦路斯: "Ciprus",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Horvátország",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Elefántcsontpart",
  库克群岛: "Cook-szigetek",
  科摩罗: "Comore-szigetek",
  哥伦比亚: "Kolumbia",
  智利: "Chile",
  乍得: "Csád",
  中非共和国: "Közép-afrikai Köztársaság",
  佛得角: "Zöld-foki Köztársaság",
  开曼群岛: "Kajmán-szigetek",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodzsa",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgária",
  文莱: "Brunei",
  巴西: "Brazília",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosznia-Hercegovina",
  玻利维亚: "Bolívia",
  不丹: "Bhután",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgium",
  白俄罗斯: "Fehéroroszország",
  巴巴多斯: "Barbados",
  孟加拉国: "Banglades",
  巴林: "Bahrein",
  巴哈马: "Bahama-szigetek",
  阿塞拜疆: "Azerbajdzsán",
  奥地利: "Ausztria",
  澳大利亚: "Ausztrália",
  阿鲁巴: "Aruba",
  亚美尼亚: "Örményország",
  阿根廷: "Argentína",
  安提瓜和巴布达: "Antigua és Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikai Szamoa",
  阿尔及利亚: "Algéria",
  中国: "Kína",
  余额不足: "Nem elegendő egyenleg",
  最低购买: "Minimális vásárlás",
  最高购买: "Maximális vásárlás",
  下单成功: "Rendelés sikeresen leadva",
  平仓成功: "Pozíció sikeresen zárva",
  请输入正确的平仓数量: "Adjon meg érvényes zárási mennyiséget",
  加仓成功: "Pozíció sikeresen növelve",
  请输入正确的加仓金额: "Adjon meg érvényes összeget a pozíciónöveléshez",
  收藏成功: "Kedvencekhez adva",
  取消收藏成功: "Eltávolítva a kedvencekből",
  加密币永续: "Kriptovaluta perpetual",
  外汇永续: "Forex perpetual",
  期权账户: "Opciós számla",
  快捷卖币: "Kriptó gyors eladása",

  托管资金: "Kezelt pénzeszközök",
  托管中: "Kezelés alatt",
  预计日收益: "Becsült napi hozam",
  累计收益: "Teljes hozam",
  周期: "Futamidő",
  日收益: "Napi hozam",
  限额: "Limit",
  立即托管: "Kezelés indítása most",
  "已鎖定 請聯繫客服": "Zárolva. Forduljon az ügyfélszolgálathoz.",
  产品列表: "Terméklista",
  规则: "Szabályok",
  创建订单: "Rendelés létrehozása",
  产品名称: "Termék neve",
  托管周期: "Kezelési időszak",
  等级限制: "Szintkorlátozás",
  托管金额: "Kezelt összeg",
  限额: "Limit",
  余额: "Egyenleg",
  购买日: "Vásárlás dátuma",
  起息日: "Kamat számításának kezdete",
  派息时间: "Kamatfizetés ideje",
  每天: "Naponta",
  计息结束日: "Kamat számításának vége",
  每日收益: "Napi hozam",
  预计收益: "Becsült hozam",
  "收益将自动发送至您的余额账户;":
    "A hozam automatikusan a számlája egyenlegére kerül;",
  "您的资金没有任何风险;": "Pénzeszközei kockázatmentesek;",
  "365*24小时不断地工作;": "24/7-ben működik, az év 365 napján;",
  托管中: "Kezelés alatt",
  结束: "Befejezve",
  今日收益: "Mai hozam",
  剩余周期: "Hátralévő futamidő",
  进行中: "Aktív",
  已发放: "Kifizetve",
  信誉分: "Hírnév pontszám",

  复制成功: "Sikeres másolás",
  VIP权益: "VIP előnyök",
  旧密码: "Régi jelszó",
  请输入旧密码: "Adja meg a régi jelszót",
  "忘记旧密码请联系客服重置。":
    "Ha elfelejtette a régi jelszavát, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal a visszaállításhoz.",
  去升级: "Frissítés",
  描述: "Leírás",
  实际存款金额: "Tényleges befizetési összeg",
  升级礼金: "Frissítési bónusz",
  隔夜利息: "Túlélési kamat (swap)",
  自动结算: "Automatikus elszámolás",
  等级规则: "Szintszabályok",
  "WEB3.0币持有数据收益": "WEB3.0 érme tartási adat hozam",
  总生产: "Teljes termelés",
  有效节点: "Aktív csomópontok",
  参与人: "Résztvevők",
  用户收益: "Felhasználói hozam",
  "流动性WEB3.0输出": "Likviditási WEB3.0 kimenet",
  总资产: "Teljes vagyon",

  ETHAI持有数据收益: "ETHAI tartási adatok hozama",
  AI量化流动性: "AI kvantitatív likviditás",
  现货买入手续费: "Spot vásárlási díj",
  现货支出: "Spot kiadás",
  现货资金费率: "Spot finanszírozási ráta",
  现货卖出手续费: "Spot eladási díj",
  现货收入: "Spot bevétel",
  外汇合约支出: "Deviza határidős ügylet kiadás",
  外汇合约买入手续费: "Deviza határidős ügylet vásárlási díj",
  外汇合约资金费率: "Deviza határidős ügylet finanszírozási ráta",
  外汇合约卖出手续费: "Deviza határidős ügylet eladási díj",
  外汇合约收入: "Deviza határidős ügylet bevétel",
  理财购买: "Befektetési termék vásárlás",
  VIP理财日收益: "VIP befektetési termék napi hozam",
  VIP理财隔夜利息: "VIP befektetési termék éjszakai kamat",
  VIP本金返还: "VIP tőke visszatérítés",
  VIP彩金发放: "VIP bónusz kifizetés",
  VIP彩金抵扣: "VIP bónusz levonás",
  隔夜利息: "Éjszakai kamat",
  设置资产密码: "Eszközjelszó beállítása",
  锁仓挖矿: "Zárolt bányászat",
  一站式理财服务: "Egyablakos pénzügyi szolgáltatás",
  产品: "Termékek",
  客服中心: "Ügyfélszolgálati központ",
  贷款: "Hitelek",
  挖矿赚不停: "Folyamatos bevétel bányászattal",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "A zárolt bányászat során a USDT (USD:1USDT=1USD) a platform nagy teljesítményű bányászati gépeihez kerül, ahol a platform bányászpooljában hozamot termel.",
  产品优势: "Termék előnyök",
  随存随取: "Bármikor befizetés és kifizetés",
  锁仓周期: "Zárolási időszak",
  每日下发: "Napi kifizetés",
  随机空投: "Véletlenszerű airdrop",
  "100%资金安全保障": "100% tőke biztonsági garancia",
  "100%节假日收益不间断": "100% folyamatos hozam ünnepnapokon is",
  成功锁仓后当天产出: "Sikeres zárolás után aznapi hozam",
  关于违约金: "Kötbér",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Ha lejárat előtt kiveszi a tőkét, kötbér kerül felszámításra. Kötbér = kötbérráta × hátralévő napok × zárolt összeg.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Példa: a kötbérráta 5%, 3 nap van hátra, a zárolt összeg 10000U (USDT/USD). Kötbér = 5%×3×10000=1500U, a ténylegesen visszatérített összeg 15000U-1500U.",
  收益计算: "Hozamszámítás",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "A platform többféle zárolt bányászati pénzügyi terméket kínál. A hozamszámítás a következő, például:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Ha a felhasználó 10000U (USDT, USD) összeget zárol, és 7 napos, napi 0,7%~1,8% hozamú terméket választ, a napi hozam:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "7 nap után 490U~1260U hozam érhető el. A hozam naponta kerül kifizetésre, a tőke lejáratkor automatikusan visszakerül a számlára.",
  正在托管的资金: "Kezelt pénzeszközök",
  签到: "Bejelentkezés",
  锁仓订单: "Zárolt megbízások",
  预计今日收益: "Mai várható hozam",
  累计收益: "Összesített hozam",
  托管中的订单: "Kezelt megbízások",
  单笔最少: "Minimum összeg",
  单笔最多: "Maximum összeg",
  日收益率: "Napi hozam",
  说明: "Leírás",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Az adatok GMT+8 idő szerint készülnek<br>2. A napi hozam a 00:00–23:59 GMT+8 között elszámolt megbízások alapján számítódik<br>3. A kifizetés másnap 00:00–00:10 GMT+8 között történik.",
  知道了: "Rendben",
  锁仓: "Zárolás",
  派息时间: "Kifizetés ideje",
  每日: "Naponta",
  托管资金: "Kezelt tőke",
  到期返回: "Lejáratkor visszatérítés",
  提前赎回: "Korai kivét",
  预计收益: "Várható hozam",
  认购: "Jegyzés",
  热门: "Népszerű",
  数字货币: "Kriptovaluták",
  贵金属: "Nemesfémek",
  大宗商品: "Áruk",
  持仓明细: "Pozíció részletei",
  历史明细: "Előzmények",
  当前价: "Jelenlegi ár",
  "↑买涨": "↑ Emelkedés vásárlása",
  "↓买跌": "↓ Csökkenés vásárlása",
  显示全部: "Összes megjelenítése",
  买入金额: "Vételi összeg",
  方向: "Irány",
  收益: "Nyereség",
  预期收益: "Várható nyereség",
  估用保证金: "Becsült fedezet",
  确认下单: "Megrendelés megerősítése",
  锁定: "Zárolva",
  账户总资产: "Teljes számlaeszköz",
  明细: "Részletek",
  今日收益: "Mai nyereség",
  仓位保证金: "Pozíció fedezet",
  持有仓位: "Nyitott pozíciók",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Zárolt összeg = az összes befejezetlen zárolt bányászati megbízás összege",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Az adatok GMT+8 szerint készülnek<br>2. A napi hozam az elszámolt megbízások alapján számítódik",
  充值方式: "Befizetési mód",
  银行汇款: "Banki átutalás",
  "银行汇款请联系客服进行操作!":
    "Banki átutaláshoz kérjük, forduljon az ügyfélszolgálathoz!",
  提款方式: "Kifizetési mód",
  "银行提款请联系客服进行操作!":
    "Banki kifizetéshez kérjük, forduljon az ügyfélszolgálathoz!",
  资金明细: "Pénzügyi részletek",
  提现记录: "Kifizetési előzmények",
  拒绝: "Elutasítva",
  通过: "Elfogadva",
  拒绝原因: "Elutasítás oka",

  消息公告: "Közlemények",
  订单: "Rendelések",
  个人中心: "Személyes központ",
  "未到期赎回需支付一定的违约金!":
    "Lejárat előtti visszaváltás esetén kötbért kell fizetni.",

  请输入区号: "Kérjük, adja meg a körzetszámot",
  "请选择国家/地区": "Kérjük, válasszon országot/régiót",

  今日开盘: "Mai nyitás",
  昨日收盘: "Tegnap zárás",

  实名认证即送: "Azonnal megkapja a személyazonosság ellenőrzése után",
  立即认证: "Ellenőrzés most",
  新用户礼包: "Új felhasználói ajándékcsomag",
  完成新人任务领取: "Teljesítse az új felhasználói feladatokat a megszerzéshez",
  认证: "Ellenőrzés",
  时间周期: "Időtartam",
  支付金额: "Fizetési összeg",
  已平仓: "Lezárva",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX új felhasználói üdvözlőcsomag: minden felhasználó legfeljebb ennyit kaphat",
  我已经阅读并同意: "Elolvastam és elfogadom",
  隐私政策: "Adatvédelmi szabályzat",

  放弃奖励离开: "Jutalom elhagyása és kilépés",
  继续注册: "Regisztráció folytatása",
  分钟: "Perc",

  "请先勾选隐私政策!":
    "Kérjük, először tekintse meg az adatvédelmi szabályzatot!",

  添加其他到自选: "Továbbiak hozzáadása a figyelőlistához",

  充值最高可得: "Töltse fel egyenlegét, és szerezzen akár 30 000 dollárt.",

  请输入格式正确的手机号: "Kérjük, adjon meg egy érvényes mobiltelefonszámot.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 匈牙利



// WEBPACK FOOTER //
// ./src/lang/xyl.js